import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import preventDirectServerAccess from 'helpers/preventDirectServerAccess';
import { phoneVerificationOnEnterSaga } from './PhoneVerification.onenter.saga'; // polyfill webpack require.ensure

if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
export var PhoneVerificationRoute = function PhoneVerificationRoute(store, client) {
  return {
    path: 'verify-phone',
    onEnter: function onEnter(nextState, replaceState, cb) {
      return store.runSagaOnce(phoneVerificationOnEnterSaga, client, nextState, replaceState).done.then(cb, cb);
    },
    getComponent: function getComponent(location, callback) {
      require.ensure([], function (require) {
        callback(null, require('./PhoneVerificationContainer').PhoneVerificationContainer);
      }, 'PhoneVerification');
    },
    getChildRoutes: function getChildRoutes(location, callback) {
      var onEnter = preventDirectServerAccess(function (loc) {
        return _objectSpread({}, loc, {
          pathname: loc.pathname.replace('/enter-code', '')
        });
      });

      require.ensure([], function (require) {
        callback(null, [{
          path: 'enter-code/**/*',
          component: require('./CodeVerificationContainer').CodeVerificationContainer,
          onEnter: onEnter
        }, {
          path: '**/*',
          component: require('./NumberInputContainer').NumberInputContainer
        }]);
      }, 'PhoneVerification');
    }
  };
};